import React from "react";
import styles from "./Layout.module.css";

const Layout = ({ children, className = "", fullHeight = false }) => {
  const layoutClass = `
    ${styles.layout} 
    ${fullHeight ? styles.fullHeight : ""} 
    ${className}
  `.trim();

  return <div className={layoutClass}>{children}</div>;
};

export default Layout;
